import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {HTH} from "../HTH";
import {HTHAvalancheReelModel} from "../reels/HTHAvalancheReelModel";
import {HTHGameConfig} from "../HTHGameConfig";

export class HTHNormalIdlePresentation implements FlowStatePresentation {
    constructor() {

    }

    public start(flowStateController: FlowStateController) {
        if (HTH.model.nextMode.includes("NORMAL") && !HTH.autoPlayPlugin.isAutoplayRound && !HTH.apiPlugin.isReplay) {
            HTH.reelArea.allReels.forEach((reel: HTHAvalancheReelModel) => {
                reel.reelView.setInteractiveSymbols(true);
            });
        }
        if (HTH.model.data.mode.indexOf("FREESPIN") > -1 || HTH.model.data.mode.indexOf("EXTRA_SPIN") > -1) {
            HTH.keypadPlugin.setZeroBetSpinCounter(-1);
        }
        HTHGameConfig.isSkipped = [false, false];
        this.onComplete(flowStateController);
    }

    private onComplete(flowStateController: FlowStateController): void {
        flowStateController.finish();
    }

    private skip(flowStateController: FlowStateController) {
        this.onComplete(flowStateController)
    }
}